export default __webpack_public_path__ + "static/media/Front-Gandini-Menswear.d1c5217d.jpg";